import {
  WorkerVersionStatus,
  type WorkerVersionStatusType,
} from "@validereinc/domain";

export type WorkerVersionStatusTransitionMapType = WorkerVersionStatusType;

export const VALID_WORKER_VERSION_STATUS_TRANSITIONS: Partial<
  Record<
    WorkerVersionStatusTransitionMapType,
    WorkerVersionStatusTransitionMapType
  >
> = {
  [WorkerVersionStatus.ACTIVE]: WorkerVersionStatus.ARCHIVED,
  [WorkerVersionStatus.ARCHIVED]: WorkerVersionStatus.ACTIVE,
};

export const getValidWorkerVersionStatusTransition = (
  status: WorkerVersionStatusTransitionMapType
) => VALID_WORKER_VERSION_STATUS_TRANSITIONS[status];
